"use strict";exports.__esModule = true;exports.loader = loader;var cachePromises = [];

function cssLoad(cssSrc, promiseKey) {
  return new Promise((resolve, reject) => {
    var head = document.head || document.getElementsByTagName('head')[0];
    var cssnode = document.createElement('link');
    cssnode.type = 'text/css';
    cssnode.rel = 'stylesheet';

    cssnode.href = cssSrc;

    cssnode.onreadystatechange = () => {
      resolve();
    };

    cssnode.onload = () => {
      resolve();
    };
    cssnode.onerror = () => {
      reject();
      delete cachePromises[promiseKey];
    };
    head.appendChild(cssnode);
  });
}

function srcLoad(src, promiseKey) {
  return new Promise((resolve, reject) => {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.src = src;

    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
      delete cachePromises[promiseKey];
    };
    head.appendChild(script);
  });
}

function restArWorker(src) {
  return new Promise((resolve) => {
    var content = "importScripts( \"" + src + "\" );";
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('noscript');
    script.textContent = content;
    script.id = 'restar-worker';

    head.appendChild(script);
    resolve();
  });
}

function loader(srcList, typeList) {
  var promiseKey = srcList.join(',');
  if (!cachePromises[promiseKey]) {
    cachePromises[promiseKey] = Promise.all(
    srcList.map((src, key) => {
      if (typeList[key]) {
        if (typeList[key] === 'css') {
          return cssLoad(src, promiseKey);
        } else if (typeList[key] === 'restar-worker') {
          return restArWorker(src, promiseKey);
        }
      }
      return srcLoad(src, promiseKey);
    }));

  }
  return cachePromises[promiseKey];
}